import React, { useState, useContext } from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CardWrap from "../Common/CardWrap";
import ResultModal from "../Common/ResultModal";
import { unitOfMeasureServices } from "../../Services";
import { lettersOnly } from "../../Config/Regex";
import { AuthContext } from "../../Contexts/AuthContext";
import { roles } from "../../Config/Roles";
import Tooltip from "../Common/Tooltip";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import { Modal } from "react-bootstrap";

const initState = {
  name: "",
  tag: "",
};

const EditUnitOfMeasure = ({ match }) => {
  const history = useHistory();
  const { t: translator } = useTranslation();

  const { register, handleSubmit, errors } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });
  const [unitOfMeasure, setUnitOfMeasure] = useState(initState);
  const [msgError, setMsgError] = useState("");
  const [resultModal, setResultModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
    success: true,
  });
  const selectedUnitOfMeasureId = match.params.unitOfMeasureId;
  const { roleId } = useContext(AuthContext);
  const { locName, locTenant, locStore } = useContext(GlobalContext);
  const { master, admin } = roles;

  React.useEffect(() => {
    if (![master, admin].includes(Number(roleId)))
      history.push("/error-page/401");
    else {
      if (selectedUnitOfMeasureId) {
        unitOfMeasureServices.getById(selectedUnitOfMeasureId).then((data) => {
          setUnitOfMeasure({
            unitOfMeasureId: data.data.data.unitOfMeasureId,
            name: data.data.data.name,
            tag: data.data.data.tag,
          });
        });
      }
    }
  }, []);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setUnitOfMeasure({ ...unitOfMeasure, [name]: value });
    setMsgError("");
  };

  const onSubmit = (data) => {
    if (selectedUnitOfMeasureId) {
      unitOfMeasureServices
        .update({
          unitOfMeasureId: selectedUnitOfMeasureId,
          name: unitOfMeasure.name,
          tag: unitOfMeasure.tag,
        })
        .then((res) => {
          res.data.success
            ? setResultModal({
                show: true,
                title: translator("EditUnitOfMeasure-Update-SuccesModal-Title"),
                text: translator("EditUnitOfMeasure-Update-SuccesModal-Text"),
                btnClass: "btn btn-primary",
                success: true,
              })
            : setResultModal({
                show: true,
                title: translator(
                  "EditUnitOfMeasure-Update-UnsuccesModal-Title"
                ),
                text: translator("EditUnitOfMeasure-Update-UnsuccesModal-Text"),
                btnClass: "btn btn-primary",
                success: false,
              });

          res.data.errors
            ? res.data.errors.map((e) => {
                setMsgError(translator(e.value));
                setResultModal({
                  show: true,
                  title: translator("EditItemGroup-Add-UnsuccessModal-Title"),
                  text: translator(e.value),
                  btnClass: "btn btn-primary",
                  success: false,
                });
              })
            : setMsgError("");
        })
        .catch((err) => console.log(err));
    } else {
      unitOfMeasureServices
        .create({
          tenantId: unitOfMeasure.tenantId && parseInt(unitOfMeasure.tenantId),
          name: unitOfMeasure.name,
          tag: unitOfMeasure.tag,
        })
        .then((res) => {
          res.data.success
            ? setResultModal({
                show: true,
                title: translator("EditItemGroup-Add-SuccessModal-Title"),
                text: translator("EditItemGroup-Add-SuccessModal-Text"),
                btnClass: "btn btn-primary",
                success: true,
              })
            : setResultModal({
                show: true,
                title: translator("EditItemGroup-Add-UnsuccessModal-Title"),
                text: translator("EditItemGroup-Add-UnsuccessModal-Text"),
                btnClass: "btn btn-primary",
                success: false,
              });

          res.data.errors
            ? res.data.errors.map((e) => {
                setMsgError(translator(e.value));
                setResultModal({
                  show: true,
                  title: translator("EditItemGroup-Add-UnsuccessModal-Title"),
                  text: translator(e.value),
                  btnClass: "btn btn-primary",
                  success: false,
                });
              })
            : setMsgError("");
        })
        .catch((err) => console.log(err));
    }
  };

  const goBack = () => {
    let backedId = 0;
    switch (locName) {
      case "tenants":
        backedId = locTenant != 0 ? locTenant : "";
        break;
      case "stores":
        backedId = locStore != 0 ? locStore : "";
        break;
      default:
        history.push("/unit-of-measures");
    }
    history.push("/unit-of-measures");
  };

  const handleCloseResultModal = () => {
    setResultModal({ show: false });
    if (resultModal.success === true) {
      goBack();
    }
  };

  const handleCancel = (e) => {
    e.preventDefault();
    history.push("/unit-of-measures");
  };

  return (
    <CardWrap
      title={translator("EditUnitOfMeasure-Title")}
      subtitle={
        (selectedUnitOfMeasureId &&
          translator("EditUnitOfMeasure-Subtitle-UnitOfMeasureEditing")) ||
        translator("EditUnitOfMeasure-Subtitle-NewUnitOgMeasure")
      }
      backUrl={"/unit-of-measures"}
    >
      <form onSubmit={handleSubmit(onSubmit)} className="row">
        <div className="col-lg-4">
          <fieldset className="scheduler-border">
            <legend className="scheduler-border">
              {translator("EditUnitOfMeasure-BasicData")}
            </legend>

            <div className="form-group">
              <label>{translator("EditUnitOfMeasure-Name")}</label>{" "}
              <Tooltip text={translator("UnitOfMeasure-Name-Msg")} />
              <input
                type="text"
                ref={register({
                  required: true,
                  pattern: lettersOnly,
                  maxLength: 20,
                })}
                className="form-control"
                name="name"
                defaultValue={unitOfMeasure.name}
                onChange={handleInputChange}
              />
              {errors.name && errors.name.type === "required" && (
                <p className="text-danger">
                  {translator("ValidationMsg-RequiredField")}
                </p>
              )}
              {errors.name && errors.name.type === "pattern" && (
                <p className="text-danger">
                  {translator("ValidationMsg-LettersOnly")}
                </p>
              )}
              {errors.name && errors.name.type === "maxLength" && (
                <p className="text-danger">
                  {translator("ValidationMsg-MaxLength20")}
                </p>
              )}
            </div>

            <div className="form-group">
              <label>{translator("EditUnitOfMeasure-Tag")}</label>{" "}
              <Tooltip text={translator("UnitOfMeasure-Tag-Msg")} />
              <input
                type="text"
                className="form-control"
                name="tag"
                ref={register({
                  required: true,
                  maxLength: 3,
                  pattern: msgError,
                })}
                defaultValue={unitOfMeasure.tag}
                onChange={handleInputChange}
              />
              {errors.tag && errors.tag.type === "required" && (
                <p className="text-danger">
                  {translator("ValidationMsg-RequiredField")}
                </p>
              )}
              {errors.tag && errors.tag.type === "maxLength" && (
                <p className="text-danger">
                  {translator("ValidationMsg-MaxLength-ThreeCharacters")}
                </p>
              )}
              {msgError !== "" ? <p className="text-danger">{msgError}</p> : ""}
            </div>
          </fieldset>
        </div>

        <div
          className="container-fluid"
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <button className="btn btn-outline-secondary" onClick={handleCancel}>
            {translator("Btn-Cancel")}
          </button>
          &nbsp;
          <button className="btn btn-primary" type="submit">
            {translator("Btn-Save")}
          </button>
        </div>
      </form>
      <ResultModal
        show={resultModal.show}
        title={resultModal.title}
        text={resultModal.text}
        btnClass={resultModal.btnClass}
        handleClose={handleCloseResultModal}
      />
    </CardWrap>
  );
};

export default EditUnitOfMeasure;
